import {ListGroup} from 'react-bootstrap';
import React from 'react';
import Icon from '../icon';
import {getChargerEntry} from '../../../../constants/chargerRegistry';
import NodeDropdown from './NodeDropdown';

const EvCharger = ({nodeDatum}) => {
  const evType = Object.keys(nodeDatum?.attributes)[0];
  const entry = getChargerEntry(evType);
  const displayName = entry?.label || evType;
  const data = nodeDatum.attributes[evType];

  const content = () => {
    if (!entry) {
      return (
        <ListGroup className="list-group-flush">
          <div><p className="mb-0"><b>{evType}</b></p></div>
        </ListGroup>
      );
    }
    return (
      <ListGroup className="list-group-flush">
        <div>
          {entry.resolvedSummary.map((sf) => (
            <p key={sf.key} className="mb-0">{sf.label}: {data?.[sf.key]}</p>
          ))}
        </div>
      </ListGroup>
    );
  };

  const [isHidden, setIsHidden] = React.useState(true);
  const handleIconClick = () => setIsHidden(!isHidden);

  return (
    <div style={{textAlign: 'left'}} className="tree-node">
      <div>
        <div className="mb-0 d-flex justify-content-between align-items-start">
          <div>
            <small style={{fontSize: 10}}>ID: {nodeDatum.name}</small>
            <br/>
            <h5>{displayName}</h5>
            {data?.name && <h6>{data.name}</h6>}
          </div>
          <div style={{position: 'relative'}} onClick={handleIconClick}>
            <div>
              <NodeDropdown isHidden={isHidden} nodeData={nodeDatum}/>
            </div>
            <div className="icon-hover">
              <Icon name="evStation" color={'var(--blue)'} size={30}/>
            </div>
          </div>
        </div>
      </div>
      {content()}
    </div>
  );
};

export default EvCharger;

